<template>
  <section 
  id="as-section-contact-agent"
  class="as-section as-section--has-padding as-section--contact-agent"
  data-section="contact-agent">
    <div class="container container--narrow">

      <h2 class="as-section__title mb-2">Get In Touch</h2>
      <template v-if="!formSubmitted">
        <p class="mb-3">Please fill out this form or use the contact information below to get in touch with your agent today! <strong>Note:</strong> fields marked with an asterisk (*) are required.</p>
      </template>
      
      <div class="row flex-column-reverse flex-md-row">
        <div class="col-md-7 col-lg-8 form-col">
          

          <template v-if="!formSubmitted">

            <form @submit.prevent="onSubmit" class="form">

              <div id="contact-agent-form-errors" class="alert danger mb-2" v-if="formValidation.$error">
                <p>There were errors with your submission. Please review it and try again.</p>
              </div>


              <div class="row">
                <div class="col-md-6">
                  <label 
                    class="rwfc rwfc--has-label" 
                    for="as-contact-input-firstname"
                    :class="formValidation.first_name.$error ? 'er' : ''">
                      <span class="the-text">First Name *</span>
                      <input 
                        class="rwfc__input" 
                        type="text" 
                        id="as-contact-input-firstname" 
                        name="first_name"
                        v-model="firstName">
                  </label>
                </div>
                <div class="col-md-6">
                  <label 
                    class="rwfc rwfc--has-label" 
                    for="as-contact-input-lastname"
                    :class="formValidation.last_name.$error ? 'er' : ''">
                      <span class="the-text">Last Name *</span>
                      <input 
                        class="rwfc__input" 
                        type="text" 
                        id="as-contact-input-lastname" 
                        name="last_name"
                        v-model="lastName">
                  </label>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-6">
                  <label 
                    class="rwfc rwfc--has-label" 
                    for="as-contact-input-email"
                    :class="formValidation.email.$error ? 'er' : ''">
                      <span class="the-text">Email *</span>
                      <input 
                        class="rwfc__input" 
                        type="email" 
                        id="as-contact-input-email" 
                        name="email"
                        v-model="email">
                  </label>
                </div>
                <div class="col-md-6">
                  <label 
                    class="rwfc rwfc--has-label" 
                    for="as-contact-input-phone"
                    :class="formValidation.phone.$error ? 'er' : ''">
                      <span class="the-text">Phone *</span>
                      <input 
                        class="rwfc__input" 
                        type="text" 
                        id="as-contact-input-phone" 
                        name="phone"
                        v-model="phone">
                  </label>
                </div>
              </div>
              

              <span class="label-text mb-1" :class="formValidation.services.$error ? 'text-danger' : ''">How can we help you? Select all that apply. *</span>
              <div class="row mb-1">
                <div class="col-lg-6 mb-1 mb-lg-0">
                  <label
                      class="rw-custom-checkbox"
                      for="as-contact-checkbox-buying"
                      :class="formValidation.services.$error ? 'rw-custom-checkbox--er' : ''">
                    <input
                        class="rw-custom-checkbox__input"
                        type="checkbox"
                        id="as-contact-checkbox-buying"
                        value="buying-properties"
                        v-model="services"
                    />
                    <span class="rw-custom-checkbox__control-indicator"></span>
                    <span class="rw-custom-checkbox__label">Buying Properties</span>
                  </label>
                </div>
                <div class="col-lg-6">
                  <label
                    class="rw-custom-checkbox"
                    for="as-contact-checkbox-pm"
                    :class="formValidation.services.$error ? 'rw-custom-checkbox--er' : ''">
                      <input
                        class="rw-custom-checkbox__input"
                        type="checkbox"
                        id="as-contact-checkbox-pm"
                        value="property-management"
                        v-model="services"
                        />
                      <span class="rw-custom-checkbox__control-indicator"></span>
                      <span class="rw-custom-checkbox__label">Property Management</span>
                  </label>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-lg-6 mb-1 mb-lg-0">
                  <label 
                    class="rw-custom-checkbox" 
                    for="as-contact-checkbox-selling" 
                    :class="formValidation.services.$error ? 'rw-custom-checkbox--er' : ''">
                      <input 
                        class="rw-custom-checkbox__input" 
                        type="checkbox" 
                        id="as-contact-checkbox-selling" 
                        value="selling-properties"
                        v-model="services"
                        />
                      <span class="rw-custom-checkbox__control-indicator"></span>
                      <span class="rw-custom-checkbox__label">Selling Properties</span>
                  </label>
                </div>
                <div class="col-lg-6">
                  <label 
                    class="rw-custom-checkbox" 
                    for="as-contact-checkbox-tp" 
                    :class="formValidation.services.$error ? 'rw-custom-checkbox--er' : ''">
                      <input 
                        class="rw-custom-checkbox__input" 
                        type="checkbox" 
                        id="as-contact-checkbox-tp" 
                        value="tenant-placement"
                        v-model="services"
                        />
                      <span class="rw-custom-checkbox__control-indicator"></span>
                      <span class="rw-custom-checkbox__label">Tenant Placement</span>
                  </label>
                </div>
              </div>

              
              <div class="row">
                <div class="col-md-6 d-md-flex d-xl-block">
                  <label 
                    class="rwfc rwfc--has-label d-md-flex d-xl-block flex-md-column" 
                    for="as-contact-input-num-properties"
                    :class="formValidation.number_of_properties.$error ? 'er' : ''">
                      <span class="the-text">How many properties? *</span>
                      <input 
                        class="rwfc__input mt-md-auto mt-xl-0" 
                        type="text" 
                        id="as-contact-input-num-properties" 
                        name="num_properties"
                        v-model="numberOfProperties">
                  </label>
                </div>
                <div class="col-md-6">
                  <label 
                    class="rwfc rwfc--has-label" 
                    for="as-contact-input-action-when"
                    :class="formValidation.timeline.$error ? 'er' : ''">
                      <span class="the-text">How soon are you looking to take action</span>
                      <div class="rwfc__dropdown-triangle-layer">
                        <select
                          name="action_when"
                          id="as-contact-input-action-when"
                          class="rwfc__input select2"
                          v-model="timeline">
                            <option value="now">Right Now</option>
                            <option value="six-months">Within 6 Months</option>
                            <option value="twelve-months">Within 12 Months</option>
                            <option value="twenty-four-months">Within 24 Months</option>
                            <option value="na">Not Sure</option>
                        </select>
                      </div>
                  </label>
                </div>
              </div>

              <label class="rwfc rwfc--has-label">
                  <span class="the-text">Message</span>
                  <textarea 
                    name="message" 
                    class="rwfc__input w-100" 
                    rows="5" 
                    v-model="contactMessage"
                    >
                  </textarea>
              </label>

              <div class="text-center mt-2 mt-lg-4">
                <button href="#" class="btn btn--cta btn--cta--pill btn--cta--primary" :disabled="formLoading" :class="{'disabled': formLoading}">
                  <template v-if="formLoading">
                    <i class="fas fa-spinner fa-spin"></i>
                  </template>
                  <template v-else>
                    <i class="fas fa-paper-airplane"></i>
                  </template>
                  <span class="the-text">Send Message</span>
                </button>
              </div>
              
            </form>
            
          </template>

          <template v-else>
            <div class="text-center p-6 bg-blue4 text-light mt-4">
              <h3>Thank you for your interest.</h3>
              <p class="text-light mt-2">{{ agent.first_name }} will be in touch shortly.</p>
            </div>
          </template>
          
        </div>
        <div class="col-md-5 col-lg-4 contact-col">
          
          <h3 class="as-section__sub-title">Contact Information</h3>
          <ul class="icon-list">
            <li class="icon-list__item">
              <i class="far fa-phone"></i>
              <a :href="`tel:${agent.phone}`" :title="`Call ${agent.first_name} ${agent.last_name}`">{{agent.phone}}</a>
            </li>
            <li class="icon-list__item">
              <i class="far fa-envelope"></i>
              <a :href="'mailto:' + agent.email" :title="`Email ${agent.first_name} ${agent.last_name}`">{{agent.email}}</a>
            </li>
          </ul>

          <h3 class="as-section__sub-title mt-3 mt-lg-4">Social Media</h3>
          <div class="d-flex justify-content-center justify-content-md-start">
            <template v-if="agent.agent_page.facebook_url">
              <a :href="agent.agent_page.facebook_url" class="social-icon" target="_blank" title="Follow Agent on Facebook">
                <span class="sr-only">Follow Agent on Facebook</span>
                <i class="fab fa-facebook"></i>
              </a>
            </template>
            <template v-if="agent.agent_page.linkedin_url">
              <a :href="agent.agent_page.linkedin_url" class="social-icon" target="_blank" title="Follow Agent on LinkedIn">
                <span class="sr-only">Follow Agent on LinkedIn</span>
                <i class="fab fa-linkedin"></i>
              </a>
            </template>
            <template v-if="agent.agent_page.instagram_url">
              <a :href="agent.agent_page.instagram_url" class="social-icon" target="_blank" title="Follow Agent on Instagram">
                <span class="sr-only">Follow Agent on Instagram</span>
                <i class="fab fa-instagram"></i>
              </a>
            </template>
            <template v-if="agent.agent_page.twitter_url">
              <a :href="agent.agent_page.twitter_url" class="social-icon" target="_blank" title="Follow Agent on Twitter">
                <span class="sr-only">Follow Agent on Twitter</span>
                <i class="fab fa-twitter"></i>
              </a>
            </template>
            <a :href="`mailto:${agent.email}`" class="social-icon" title="Contact Agent via Email">
              <span class="sr-only">Contact Agent via Email</span>
              <i class="fas fa-envelope"></i>
            </a>
          </div>
          
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import WaypointMixin from '@vue/mixins/waypoint-mixin';
export default {
  mixins: [
    WaypointMixin
  ],
  props: {
    agent: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    formValidation: {
      type: Object,
      required: true
    },
    formLoading: {
      type: Boolean,
      default: false
    },
    formSubmitted: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    this.$addObserver(this.$el, this.onWaypointEnter, this.intersectionOptions);
  },

  computed: {
    email: {
      get(){ return this.formData.email; },
      set(value){
        this.onInput('email', value);
      }
    },
    phone: {
      get(){ return this.formData.phone; },
      set(value){
        this.onInput('phone', value);
      }
    },
    firstName: {
      get(){ return this.formData.first_name; },
      set(value){
        this.onInput('first_name', value);
      }
    },
    lastName: {
      get(){ return this.formData.last_name; },
      set(value){
        this.onInput('last_name', value);
      }
    },
    services: {
      get(){ return this.formData.services; },
      set(value){
        this.onInput('services', value);
      }
    },
    numberOfProperties: {
      get(){ return this.formData.number_of_properties; },
      set(value){
        this.onInput('number_of_properties', value);
      }
    },
    timeline: {
      get(){ return this.formData.timeline; },
      set(value){
        this.onInput('timeline', value);
      }
    },
    contactMessage: {
      get(){ return this.formData.comments; },
      set(value){
        this.onInput('comments', value);
      }
    },
  },

  methods: {

    onInput(field, value){
      let obj = {};
      obj[field] = value;
      this.$emit('contact-field-change', obj)
    },

    onSubmit(){
      this.$emit('contact-form-submit');
    }
    
  }
  
}
</script>